import styled from "styled-components";

export const Container = styled.div`
  padding-left: 160px;
  height: 100%;
  margin-right: 8px;
  overflow: auto;
`;
